import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-3 pt-3"
}

import { computed, ref, watch } from "vue";
import ModalSorteo from "../ModalSorteo.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalAddEquipo from "./ModalAddEquipo.vue";
import ModalParametrosPrimeraRondaEquipo from "./ModalParametrosPrimeraRondaEquipo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionAccionesTorneoEquipo',
  props: {
    torneo: {},
    rondaGenerada: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const esParejas = computed(() => props.torneo?.torneo.tipoTorneo === "Parejas");
const isLoading = ref<boolean>(true);
const isGenerating = ref<boolean>(false);
const showConfigModal = ref<boolean>(false);
const showSorteoModal = ref<boolean>(false);
const showModalAddEquipo = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const nicks = ref<string[]>([]);

const openConfigModal = async () => {
  // Con la ronda 1 ya generada no se vuelve a generar
  if (!props.torneo || props.rondaGenerada || isGenerating.value) return;
  isGenerating.value = true;

  showConfigModal.value = true;
};

const openSorteo = async () => {
  isLoading.value = true;

  if (props.torneo) {
    nicks.value = props.torneo.equipos.flatMap((equipo) =>
      equipo.inscripciones.map((i) => i.nick)
    );
  }

  showSorteoModal.value = true;
  isLoading.value = false;
};

const closeSorteoModal = () => {
  showSorteoModal.value = false;
};

const openAddEquipo = async () => {
  showModalAddEquipo.value = true;
};

const closeConfigModal = () => {
  showConfigModal.value = false;
  isGenerating.value = false;
};

const closeModalAddEquipo = () => {
  showModalAddEquipo.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
  window.location.reload();
};

const handleAddEquipoConfirm = () => {
  showModalAddEquipo.value = false;
  showSuccessModal.value = false;
  window.location.reload();
};

__expose({ abrirGenerarRonda1: openConfigModal, abrirSorteo: openSorteo });

watch(
  () => showSuccessModal.value,
  (newValue) => {
    if (!newValue) {
      window.location.reload();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.torneo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          block: "",
          variant: "tonal",
          color: "secondary",
          onClick: openAddEquipo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(esParejas.value ? "Añadir pareja" : "Añadir equipo"), 1)
          ]),
          _: 1
        }),
        _createVNode(ModalParametrosPrimeraRondaEquipo, {
          isVisible: showConfigModal.value,
          torneo: _ctx.torneo,
          onClose: closeConfigModal,
          onConfirm: handleConfigConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalAddEquipo, {
          isVisible: showModalAddEquipo.value,
          torneo: _ctx.torneo,
          onClose: closeModalAddEquipo,
          onConfirm: handleAddEquipoConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalSorteo, {
          isVisible: showSorteoModal.value,
          participantes: nicks.value,
          onClose: closeSorteoModal
        }, null, 8, ["isVisible", "participantes"])
      ]))
    : _createCommentVNode("", true)
}
}

})